import { render } from "./MenuSelect.vue?vue&type=template&id=404c5568"
import script from "./MenuSelect.vue?vue&type=script&lang=js"
export * from "./MenuSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__